import { Box, TextField } from "@mui/material";
import { useEffect, useState } from "react";

interface PassportInputProps {
  passport: string;
  setPassport: (value: string) => void;
  setIsValid?: (valid: boolean) => void;
}

export default function PassportInput({
  passport,
  setPassport,
  setIsValid,
}: PassportInputProps) {
  const [touched, setTouched] = useState(false);

  const isValidPassport = (value: string) => /^[A-Z0-9]{5,20}$/i.test(value);

  const error =
    touched && (!passport || !isValidPassport(passport))
      ? !passport
        ? "El número de pasaporte es obligatorio"
        : "Número de pasaporte inválido"
      : "";

  useEffect(() => {
    if (setIsValid) setIsValid(!!passport && isValidPassport(passport));
  }, [passport]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      <TextField
        label="Número de pasaporte"
        variant="outlined"
        fullWidth
        value={passport}
        onChange={(e) => setPassport(e.target.value.trim().toUpperCase())}
        onBlur={() => setTouched(true)}
        error={Boolean(error)}
        helperText={error}
        placeholder="AB1234567"
        inputProps={{
          maxLength: 20,
          style: { fontSize: 16, textTransform: "uppercase" },
        }}
        sx={{
          bgcolor: "#F6F8FB",
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: error ? "#f44336" : "#ccc",
            },
            "&:hover fieldset": {
              borderColor: "#888",
            },
            "&.Mui-focused fieldset": {
              borderColor: error ? "#f44336" : "#1976d2",
            },
          },
        }}
      />
    </Box>
  );
}
